import { render, staticRenderFns } from "./SettingChartTheme.vue?vue&type=template&id=67338c04"
import script from "./SettingChartTheme.vue?vue&type=script&lang=js"
export * from "./SettingChartTheme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports